import { render } from "./InterviewRecordings.vue?vue&type=template&id=6718780e&scoped=true"
import script from "./InterviewRecordings.vue?vue&type=script&lang=js"
export * from "./InterviewRecordings.vue?vue&type=script&lang=js"

import "./InterviewRecordings.vue?vue&type=style&index=0&id=6718780e&lang=scss&scoped=true"

import exportComponent from "/build/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6718780e"]])

export default __exports__